import React from 'react';
import { useAuth } from '../auth/useAuth';

const Settings: React.FC = () => {
  const { user, signOut } = useAuth();

  return (
    <div className="space-y-6 max-w-xl">
      <h1>Settings</h1>
      <div className="card-padded space-y-4">
        <h3>Profile</h3>
        <div>
          <div className="label">Email</div>
          <div className="text-sm text-slate-900">{user?.email || '—'}</div>
        </div>
        <div>
          <div className="label">Name</div>
          <div className="text-sm text-slate-900">{user?.name || '—'}</div>
        </div>
        <div className="pt-2 border-t border-slate-200">
          <button onClick={signOut} className="btn-danger">Sign out</button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
